import * as React from 'react';
import { SVGProps } from 'react';

const SvgBellFull = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.625 14.359C9.625 15.261 8.894 16 8 16a1.638 1.638 0 0 1-1.625-1.641h3.25Zm3.25-7.385v4.103l1.625 1.64v.822h-13v-.821l1.625-1.641V6.974c0-2.527 1.332-4.627 3.656-5.185V1.23C6.781.55 7.326 0 8 0s1.219.55 1.219 1.23v.559c2.332.558 3.656 2.666 3.656 5.185Z"
      fill="#174174"
    />
  </svg>
);

export default SvgBellFull;
